<template>
  <div class="see-model-dia">
    <el-dialog
      title="查看审单人"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="800px"
      top="3%"
      @close="close"
    >
      <el-table
        ref="companyDia"
        :data="dialogTableData"
        v-loading="diaLoading"
        tooltip-effect="dark"
        border
      >
        <el-table-column type="index" align="center" label="序号" width="50" />
        <el-table-column label="人员姓名" align="center">
          <template slot-scope="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              :content="row.staffName"
              placement="top"
            >
              <div class="nowrap-ellipsis">
                {{ row.staffName }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="人员姓名" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isMajor?'创建人':row.staffType=='01'?'子账号':row.staffType=='02'?'总监':row.staffType=='03'?'店长':'店员' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="isEdit" align="center" width="100px">
          <template slot-scope="{ row }">
            <el-button type="danger" size="small" @click="delMachine(row)"
              >移除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="close">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    auditIds: {
      type: Array,
      default: () => {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      diaLoading: false,
      dialogTableData: [],
      rowCompanyId: "",
    };
  },

  created() {
    this.dialogSearchCompany();
  },
  watch: {
    auditIds() {
      this.dialogSearchCompany();
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    dialogSearchCompany() {
      this.diaLoading = true;
      _api
        .getBlacklistAuditStaffList({
          auditIds: this.auditIds,
          type: "00",
        })
        .then((res) => {
          this.dialogTableData = res.data;
        })
        .finally(() => {
          this.diaLoading = false;
        });
    },
    // 移除操作
    delMachine(row) {
      this.$emit('delMachine',row.id)
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.see-model-dia {
  .nowrap-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .flex-je {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  /deep/.el-form-item {
    margin-bottom: 10px !important;
  }
}
</style>
